export default __webpack_public_path__ + "static/media/11.50e5617a.png";